<template>
  <div class="about">
    <AboutDesc class="desc" />
  </div>
</template>
<script>
import AboutDesc from "@/components/AboutDesc";
export default {
  created() {
    document.title = `${this.$t("app.title")} ${this.$t("app.title_suffix")}`;
  },
  components: {
    AboutDesc
  }
};
</script>
<style lang="less">
.about {
  .desc {
    margin: 0 auto;
  }
}
</style>